import { BoilerAdapter, BoilerAdapterProtocol, get_z3k_object_state, HeatingCircuit, } from 'z3k-config';
import { createSelector } from '@reduxjs/toolkit';
import { otHasError } from './components/fail-card/utils';
import { getLegacyBoilerHeatingCircuits, getLegacyBoilerOTState, } from 'console/shared/content/device/heating-circuits/legacy/boiler';
import { removeNulls } from 'utils';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
export const select_z3k_boiler_adapters = createSelector((dev) => dev?.z3k_config, (dev) => dev?.z3k_state, (config, state) => BoilerAdapter.get
    .where(config, (ba) => BoilerAdapter.isEnabled(ba) &&
    HeatingCircuit.get.some(config, ({ control_devices }) => control_devices.includes(ba.id)))
    .map(({ id, name, type, boiler_model }) => {
    const hc = HeatingCircuit.get.one(config, ({ control_devices }) => control_devices.includes(id));
    const hc_state = hc != null ? get_z3k_object_state(state, hc.id) : null;
    const ba_state = get_z3k_object_state(state, id);
    return {
        id: hc?.id ?? -1,
        name: fixObjectName(hc?.name ?? ''),
        boiler_model,
        boiler_type: type,
        ot_boiler_state: {
            id,
            name,
            ot_state: ba_state?.ot,
            ba_status: ba_state?.status,
        },
        is_fail: hc_state != null
            ? HeatingCircuit.isFail(hc_state) ||
                otHasError(boiler_model, ba_state?.ot, ba_state?.status)
            : false,
    };
}));
export const selectLegacyBoilerAdapters = createSelector(getLegacyBoilerHeatingCircuits, (device) => device.last_boiler_state, (device) => device.otzones_last, (boiler_adapters_config, last_boiler_state, otzones_last) => {
    const configs = removeNulls(Array.isArray(boiler_adapters_config)
        ? boiler_adapters_config
        : [boiler_adapters_config]);
    const boiler_adapters = configs
        .filter((ba) => !ba.is_relay)
        .map((config) => {
        const { id, boiler_model, name } = config;
        const ot_state = getLegacyBoilerOTState(id, last_boiler_state, otzones_last);
        const is_fail = last_boiler_state?.fail || otHasError(boiler_model, ot_state, null);
        const ot_boiler_state = {
            id,
            name,
            ot_state,
            ba_status: null,
        };
        const content = {
            ...config,
            ot_boiler_state,
            is_fail,
            boiler_type: BoilerAdapterProtocol.OPENTHERM,
        };
        return content;
    });
    return boiler_adapters;
});
